import React from 'react'
import styles from './Language.module.css'


export const Language = ({ name, level }) => (
  <div className={styles.language}>
    <div className={styles.name}>{name}</div>
    <div className={styles.level}>{level}</div>
  </div>
)